import React, { useState, useEffect } from 'react';
import LayoutAndQuoteBuilderNavSection from 'components/layout_and_quote_builder/LayoutAndQuoteBuilderNavSection.jsx';

const LayoutNavSectionList = (props) => {
  const [requiredParts, setRequiredPartsInternal] = useState([]);
  const [selectedParts, setSelectedPartsInternal] = useState({});
  const [selectedPartsNormalised, setSelectedPartsNormalised] = useState([]);

  const [selectedMembers, setSelectedMembersInternal] = useState({});
  const [selectedMembersNormalised, setSelectedMembersNormalised] = useState([]);

  const [activeRedraws, setActiveRedraws] = useState([]);

  // Track selectedList for each section by index
  // Initialize from saved user_quote_nav_sections if available
  const getInitialSelectedLists = () => {
    const initialLists = {};
    if (window.user_quote_nav_sections) {
      window.user_quote_nav_sections.forEach((navSection) => {
        if (navSection.selected_lists && navSection.selected_lists.length > 0) {
          initialLists[navSection.sort_order] = navSection.selected_lists;
        }
      });
    }
    return initialLists;
  };
  const [sectionSelectedLists, setSectionSelectedLists] = useState(getInitialSelectedLists);

  const setRequiredParts = (parts) => {
    setRequiredPartsInternal( (previous) => previous.concat(parts) )
  }

  const setSelectedParts = (parts, id) => {
    setSelectedPartsInternal( (previous) => {
      previous[id] = parts;
      return { ...previous };
    });
  }

  const updateSelectedPartsNormalised = () => {
    let res = [];
    for (const index in selectedParts) {
      res = res.concat(selectedParts[index]).flat();
    }
    setSelectedPartsNormalised(res);
  }

  const setSelectedMembers = (members, id) => {
    setSelectedMembersInternal( (previous) => {
      previous[id] = members;
      return { ...previous };
    });

    setSelectedParts(members.map((member) => member.part_names).flat(), id);
  }

  const updateSelectedMembersNormalised = () => {
    let res = [];
    for (const index in selectedMembers) {
      res = res.concat(selectedMembers[index]).flat();
    }
    setSelectedMembersNormalised(res);
  }

  const missingParts = () => {
    return requiredParts.filter((part) => { return selectedPartsNormalised.indexOf(part) == -1});
  }

  const setSectionSelectedList = (index, selectedList) => {
    setSectionSelectedLists((previous) => {
      previous[index] = selectedList;
      return { ...previous };
    });
  }

  useEffect(updateSelectedPartsNormalised, [selectedParts]);
  useEffect(updateSelectedMembersNormalised, [selectedMembers]);
  useEffect(() =>{ window.selectedMembersNormalised = selectedMembersNormalised} , [selectedMembersNormalised]);

  useEffect(() => {
    if(activeRedraws.length > 0) {
      $(".RedrawLayoutButton").attr('disabled', 'disabled');
      $(".RedrawLayoutButtonImg").attr('src', window.redrawLoadingPngUrl);
      disableDownloadButtons();
    } else {
      enableDownloadButtons();
    }

    $("#RedrawLayoutButton").removeAttr('disabled');
    $("#RedrawLayoutButtonImg").attr('src', window.redrawRefreshPngUrl);
  }, [activeRedraws]);

  return (<>
    {props.navSections.map((navSection, index) => {
      const previousSelectedList = index > 0 ? (sectionSelectedLists[index - 1] || []) : null;
      const currentSelectedList = sectionSelectedLists[index] || [];

      return <LayoutAndQuoteBuilderNavSection
        key={`navSection_${index}`}
        setSelectedMembers={setSelectedMembers}
        activeRedraws={activeRedraws}
        setActiveRedraws = {setActiveRedraws}
        navSection={navSection}
        totalNavSectionSize={props.navSections.length}
        index={index}
        setRequiredParts={setRequiredParts}
        count={props.count}
        config={props.config}
        previousSelectedList={previousSelectedList}
        selectedList={currentSelectedList}
        setSelectedList={(selectedList) => setSectionSelectedList(index, selectedList)}
      />})}
    </>
  )
}

export default LayoutNavSectionList;
